'use strict';

(function () {
  'use strict';

  angular.module('msTracker').component('msMoodIcon', {
    template: '<svg-icon\n                    role="figure"\n                    icon-id="mood-icon-{{::$ctrl.moodValue| trackerValueToButtonIndex }}"\n                    aria-hidden="{{$ctrl.tracker ? false : true}}"\n                    aria-label="{{::$ctrl.moodValue | trackerValueToButtonIndex | trackerButtonIndexToLabel:$ctrl.tracker}}">\n                 </svg-icon>',
    bindings: {
      moodValue: '<',
      tracker: '<'
    }
  });
})();